import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaUserTie, FaCode, FaProjectDiagram, FaCheckCircle, FaUsers, FaMobileAlt, FaLaptopCode, FaClipboardList } from 'react-icons/fa';
import '../assets/styles/CloudStartPlan.css'; 

const CloudStartUpPlan = () => {
    return (
        <Container className="cloud-startup-plan py-5">
            <Row className="justify-content-center">
                {/* Startup Plan */}
                <Col md={5} className="mb-4">
                    <Card className="plan-card">
                        <Card.Body>
                            <Card.Title className="plan-title">STARTUP PLAN</Card.Title>
                            <Card.Subtitle className="plan-subtitle">COST-EFFECTIVENESS MEETS SKILL, SPEED, AND EFFICIENCY.</Card.Subtitle>
                            <ul className="plan-list">
                                <li><FaUserTie /> UI/UX Designer</li>
                                <li><FaCode /> A Developer</li>
                                <li><FaProjectDiagram /> Project Coordinator</li>
                                <li><FaCheckCircle /> QA Engineer</li>
                                <li><FaUsers /> HR Specialist</li>
                            </ul>
                        </Card.Body>
                        <Card.Footer className="text-center">
                            <Button className="plan-button">Book Free Consultation</Button>
                        </Card.Footer>
                    </Card>
                </Col>
                
                {/* Enterprise Plan */}
                <Col md={5} className="mb-4">
                    <Card className="plan-card">
                        <Card.Body>
                            <Card.Title className="plan-title">ENTERPRISE PLAN</Card.Title>
                            <Card.Subtitle className="plan-subtitle">WORLD-CLASS TALENT FOR COMPLEX DEVELOPMENT PROJECTS</Card.Subtitle>
                            <ul className="plan-list">
                                <li><FaClipboardList /> Project Manager</li>
                                <li><FaLaptopCode /> Solution Architect</li>
                                <li><FaUserTie /> UI/UX Designer</li>
                                <li><FaCode /> Full-Stack Developer</li>
                                <li><FaMobileAlt /> iOS Developer</li>
                                <li><FaMobileAlt /> Android Developer</li>
                                <li><FaCheckCircle /> QA Engineer</li>
                            </ul>
                        </Card.Body>
                        <Card.Footer className="text-center">
                            <Button className="plan-button">Book Free Consultation</Button>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>

            <Row className="justify-content-center">
                {/* Custom Plan */}
                <Col md={10}>
                    <Card className="plan-card custom-plan">
                        <Card.Body>
                            <Card.Title className="plan-title">CUSTOM PLAN</Card.Title>
                            <Card.Subtitle className="plan-subtitle">YOUR PERSONALIZED ROADMAP TO A SUCCESSFUL PRODUCT</Card.Subtitle>
                            <Row>
                                <Col md={6}>
                                    <ul className="plan-list">
                                        <li><FaUserTie /> Business Manager</li>
                                        <li><FaCode /> Full-Stack Developer</li>
                                        <li><FaClipboardList /> Project Manager</li>
                                        <li><FaMobileAlt /> iOS Developer</li>
                                        <li><FaLaptopCode /> Solution Architect</li>
                                    </ul>
                                </Col>
                                <Col md={6}>
                                    <h5 className="exclusive-benefits">Exclusive Benefits:</h5>
                                    <ul className="plan-list">
                                        <li><FaCheckCircle /> Reduced Hourly Rates</li>
                                        <li><FaClipboardList /> Project Management Suite</li>
                                        <li><FaUserTie /> 60 Hours of UI/UX and Front-end</li>
                                    </ul>
                                </Col>
                            </Row>
                        </Card.Body>
                        <Card.Footer className="text-center">
                            <Button className="plan-button">Book Free Consultation</Button>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default CloudStartUpPlan;